import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnnouncementDetails from './AnnouncementDetails';
import axios from '../lib/axios';

export default class AnnouncementPopover extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);

    const featuredItem = this.props.items.find(i => !i.read && i.featured);
    this.state = {
      announcement: featuredItem || null,
    };
  }

  trackLinkClick = (e) => {
    const link = $(e.target);
    axios.post(this.props.linkClicksUrl, { ids: [link.data('notification-id')] });
  }

  close = () => {
    if (this.state.announcement.featured) {
      axios.post(this.props.clicksUrl, { ids: [this.state.announcement.id] });
    }
    this.setState({ announcement: null });
  }

  componentDidMount() {
    $(document).on('announcement-click', (e, announcement) => {
      this.setState({ announcement });
    });
  }

  componentWillUnmount() {
    $(document).off('announcement-click');
  }

  render() {
    if (this.state.announcement !== null) $('body').addClass('is-overlayVisible');
    else $('body').removeClass('is-overlayVisible');

    return (this.state.announcement !== null &&
      <div>
        <div className="Popover-overlay u-inset-0 u-block" onClick={this.close} />
        <div className="Popover Popover--open Popover--announcement animated bounceIn">
          <AnnouncementDetails {...this.state.announcement} trackLinkClick={this.trackLinkClick} onClose={() => this.close} />
        </div>
      </div>
    );
  }
}
